import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import { RootStoreProvider } from './context/storeContext';
import i18 from './i18n/config';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18}>
      <RootStoreProvider>
        <App />
      </RootStoreProvider>
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();
